<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import IconRight from './TextInputWithRightIcon.svelte';

  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here (2:00)';
  export let danger: boolean = false;
  export let dangerMessage: string = '';

  export let value: string = '';

  export let inputValue: string = '';

  export let options: string[] = ['AM', 'PM'];

  export let sideValue: string = options[0];

  export let checkFormat: (value: string) => boolean = () => {
    if (!inputValue) return false;
    return true;
  };

  export let checkChars: (value: string) => boolean = () => {
    if (!inputValue) return false;
    return true;
  };

  let isfocused: boolean = false;

  const validateFormat = () => {
    isfocused = false;

    if (!inputValue && danger && dangerMessage) return;

    value = `${inputValue} ${sideValue}`;

    if (checkFormat(value)) {
      danger = false;
      dangerMessage = null;
    } else {
      danger = true;
      dangerMessage = 'Invalid time format';
    }
  };

  const validateChars = (e: CustomEvent<{ value: string }>) => {
    const value = e.detail.value;

    if (!checkChars(value)) {
      e.detail.value = value.substring(0, value.length - 1);
      inputValue = value.substring(0, value.length - 1);
    } else {
      danger = false;
      dangerMessage = null;
    }
  };

  const dispatch = createEventDispatcher();

  $: {
    if (value && !inputValue && !isfocused) {
      inputValue = value.split(' ')[0];
      sideValue = value.slice(-2);
    }

    dispatch('change', { sideValue, label, value, inputValue });
  }
</script>

<IconRight
  bind:label
  bind:caption
  bind:value={inputValue}
  bind:placeholder
  bind:danger
  bind:dangerMessage
  on:focus={() => {
    isfocused = true;
  }}
  on:blur={validateFormat}
  on:change={validateChars}
>
  <div class="flex flex-col justify-center items-center text-sm text-garden-grey-400">
    {#each options as option}
      <span
      role="button" 
tabindex="0"
        class="cursor-pointer"
        class:time-selected={sideValue === option}
        on:click={() => {
          sideValue = option;
          validateFormat();
        }}
        on:keydown
      >
        {option}
      </span>
    {/each}
  </div>
</IconRight>

<style type="postcss">
  .time-selected {
    @apply text-garden-grey-600 font-semibold ease-in-out duration-200;
  }
</style>
